<template>
	<div>
		<div class="box">
			<div class="con" style="display: flex;justify-content: space-between;">
				<div>
					<img class="logo" src="../assets/logo2.png" alt="">
					<div class="p fc">
						<img src="../assets/phone.png" alt="">
						<div>电话：</div>
						<div style="font-size: 20px;">{{info.phone}}</div>
					</div>
					<div class="p fc">
						<img src="../assets/address.png" alt="">
						<div>地址：</div>
						<div>{{info.address}}</div>
					</div>
					<div>关注我们</div>
					<div>
						<img src="../assets/wx.png" alt=""
							style="width: 38px;height: 38px;margin: 23px 0;margin-right: 20px;">
						<img src="../assets/wb.png" alt="" style="width: 38px;height: 38px;margin: 23px 0;">
					</div>
				</div>
				<div style="display: flex;">
					<div class="navitem">
						<div>平台首页</div>
					</div>
					<div class="navitem">
						<div>招标公告</div>
						<div class="a" @click="jump(1)">工程专区</div>
						<div class="a" @click="jump(2)">物资采购</div>
					</div>
					<div class="navitem">
						<div>公示公告</div>
						<div class="a" @click="jump(3)">答疑澄清修改</div>
						<div class="a" @click="jump(4)">中标候选人公示</div>
						<div class="a" @click="jump(5)">中标结果公示</div>
						<div class="a" @click="jump(6)">招标异常公告</div>
					</div>
					<div class="navitem">
						<div>办事指南</div>
						<div class="a" @click="jump(7)">供应商入库指南</div>
						<div class="a" @click="jump(8)">投标指南</div>
					</div>
					<div class="navitem">
						<div>联系我们</div>
					</div>
				</div>
			</div>
			<div class="bom fcs">
				<div @click="gopage('https://beian.miit.gov.cn')">{{info.beian}}</div>
				<div class="fc">
					<div>技术支持：</div>
					<img src="../assets/logo3.png" alt="" style="width: 90px;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer',
		props: {},
		data() {
			return {
				info: {
					phone: '',
					address: ''
				}
			}
		},
		created() {
			this.getinfo();
		},
		methods: {
			//获取展示信息
			getinfo() {
				this.$api.home.other().then(res => {
					if (res.code == 1) {
						this.info = res.data
					}
				})
			},
			jump(id) {
				if (id == 1 || id == 2) {
					this.$router.push({
						path: '/news1',
						query: {
							id: id
						}
					})
					sessionStorage.setItem('pagepath', '/news1')
				} else if (id == 3 || id == 4 || id == 5 || id == 6) {
					this.$router.push({
						path: '/news2',
						query: {
							id: id
						}
					})
					sessionStorage.setItem('pagepath', '/news2')
				} else {
					this.$router.push({
						path: '/news3',
						query: {
							id: id
						}
					})
					sessionStorage.setItem('pagepath', '/news3')
				}
			},
			gopage(url) {
				window.open(url, "_blank");
			}
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 436px;
		background: #0B457A;
		box-sizing: border-box;
		padding-top: 38px;
	}

	.box .con {
		width: 1200px;
		color: #ffffff;
		margin: 0 auto;
		border-bottom: #325372 solid 2px;
	}

	.box .con .logo {
		width: 400px;
	}

	.box .con .p {
		font-size: 14px;
		opacity: 0.9;
		margin: 20px 0;
	}

	.box .con .p img {
		width: 18px;
		height: 18px;
		margin-right: 13px;
	}

	.box .con .navitem {
		width: 125px;
		text-align: center;
		font-size: 16px;
		cursor: pointer;
		margin-top: 40px;
	}

	.box .con .navitem .a {
		color: #9C9C9C;
		margin-top: 12px;
	}

	.box .bom {
		width: 1200px;
		height: 75px;
		color: #ffffff;
		font-size: 16px;
		margin: 0 auto;
		cursor: pointer;
	}
</style>